import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { GungCommonModule } from 'gung-common';
import { DashboardCardService, DashboardKpiService, GungDashboardModule } from 'gung-dashboard';
import { FilterListService, GungListModule } from 'gung-list';
import {
  ActivityInternalListConfigService,
  AvailabilityHelperService,
  BackendInterceptor,
  CartConfigService,
  CartService,
  CheckoutConfigService,
  CheckoutQuantityValidationService,
  CustomPageConfigService,
  CustomPageResolverService,
  CustomerContactListConfigService,
  CustomerListConfigService,
  CustomerService,
  DeliveryDateService,
  DigitalAssetsListConfigService,
  GOOGLE_ANALYTICS_ID,
  GungModalService,
  GungStandardModule,
  NavbarCartService,
  NavbarConfigService,
  OpenOrdersConfigService,
  PriceConfigService,
  PriceService,
  ProductListByIdsConfigService,
  ProductListConfigService,
  SalesCartConfigService,
  TranslationLocalService,
  UsersService,
  createTranslateLocalLoader
} from 'gung-standard';
import {
  GungStandardJeevesModule,
  JeevesCustomerActionConfigService,
  JeevesModalService,
  JeevesOrderActionConfigService
} from 'gung-standard-jeeves';
import { NgChartsModule } from 'ng2-charts';
import { environment } from '../environments/environment';
import { ColmecAppComponent } from './colmec-app.component';
import { ColmecAvailabilityWarningComponent } from './components/availability/colmec-availability-warning/colmec-availability-warning.component';
import { ColmecBuyBtnComponent } from './components/buy-btn/colmec-buy-btn/colmec-buy-btn.component';
import { ColmecRimCardComponent } from './components/buy-btn/colmec-rim-card/colmec-rim-card.component';
import { ColmecRimListByIdsComponent } from './components/buy-btn/colmec-rim-list-by-ids/colmec-rim-list-by-ids.component';
import { ColmecRimOptionsModalComponent } from './components/buy-btn/colmec-rim-options-modal/colmec-rim-options-modal.component';
import { ColmecAdminCartRowComponent } from './components/cart/colmec-admin-cart-row/colmec-admin-cart-row.component';
import { ColmecCartItemComponent } from './components/cart/colmec-cart-item/colmec-cart-item.component';
import { ColmecCartListButtonsComponent } from './components/cart/colmec-cart-list-buttons/colmec-cart-list-buttons.component';
import { ColmecCartListLayoutComponent } from './components/cart/colmec-cart-list-layout/colmec-cart-list-layout.component';
import { ColmecCartSummaryComponent } from './components/cart/colmec-cart-summary/colmec-cart-summary.component';
import { ColmecSalesCartListComponent } from './components/cart/colmec-sales-cart-list/colmec-sales-cart-list.component';
import { ColmecSalesCartRowComponent } from './components/cart/colmec-sales-cart-row/colmec-sales-cart-row.component';
import { ColmecButtonsComponent } from './components/checkout/colmec-buttons/colmec-buttons.component';
import { ColmecCartTotalStepComponent } from './components/checkout/colmec-cart-total-step/colmec-cart-total-step.component';
import { ColmecCheckoutWrapperComponent } from './components/checkout/colmec-checkout-wrapper/colmec-checkout-wrapper.component';
import { ColmecOrderConfirmationComponent } from './components/checkout/colmec-order-confirmation/colmec-order-confirmation.component';
import { ColmecAssignJeevesDefaultsComponent } from './components/checkout/steps/colmec-assign-jeeves-defaults/colmec-assign-jeeves-defaults.component';
import { ColmecCheckoutStepOrderTermsUserComponent } from './components/checkout/steps/colmec-checkout-step-order-terms-user/colmec-checkout-step-order-terms-user.component';
import { ColmecCheckoutStepOrderTermsComponent } from './components/checkout/steps/colmec-checkout-step-order-terms/colmec-checkout-step-order-terms.component';
import { ColmecDeliveryLocationsJeevesComponent } from './components/checkout/steps/colmec-delivery-locations-jeeves/colmec-delivery-locations-jeeves.component';
import { ColmecSummarizeOrderJeevesComponent } from './components/checkout/steps/colmec-summarize-order-jeeves/colmec-summarize-order-jeeves.component';
import { ColmecActivityInternalCreateModalComponent } from './components/colmec-activity-internal-create-modal/colmec-activity-internal-create-modal.component';
import { ColmecActivityInternalTableComponent } from './components/colmec-activity-internal-table/colmec-activity-internal-table.component';
import { ColmecActivityInternalViewModalComponent } from './components/colmec-activity-internal-view-modal/colmec-activity-internal-view-modal.component';
import { ColmecAddContactModalComponent } from './components/colmec-add-contact-modal/colmec-add-contact-modal.component';
import { ColmecAddCustomerModalComponent } from './components/colmec-add-customer-modal/colmec-add-customer-modal.component';
import { ColmecAppWrapperComponent } from './components/colmec-app-wrapper/colmec-app-wrapper.component';
import { ColmecCheckoutStepDubbingComponent } from './components/colmec-checkout-step-dubbing/colmec-checkout-step-dubbing.component';
import { ColmecClaimCreateModalComponent } from './components/colmec-claim/colmec-claim-create-modal/colmec-claim-create-modal.component';
import { ColmecClaimGridViewComponent } from './components/colmec-claim/colmec-claim-grid-view/colmec-claim-grid-view.component';
import { ColmecClaimListComponent } from './components/colmec-claim/colmec-claim-list/colmec-claim-list.component';
import { ColmecClaimTableViewComponent } from './components/colmec-claim/colmec-claim-table-view/colmec-claim-table-view.component';
import { ColmecConceptDetailsModalComponent } from './components/colmec-concept-details-modal/colmec-concept-details-modal.component';
import { ColmecConceptDetailsComponent } from './components/colmec-concept-details/colmec-concept-details.component';
import { ColmecConceptProductsTableComponent } from './components/colmec-concept-products-table/colmec-concept-products-table.component';
import { ColmecCreateEditPartnerAgreementModalComponent } from './components/colmec-create-edit-partner-agreement-modal/colmec-create-edit-partner-agreement-modal.component';
import { ColmecCustomerContactCardListComponent } from './components/colmec-customer-contact-card-list/colmec-customer-contact-card-list.component';
import { ColmecCustomerDetailsComponent } from './components/colmec-customer-details/colmec-customer-details.component';
import { ColmecDigitalAssetsGridViewComponent } from './components/colmec-digital-assets-grid-view/colmec-digital-assets-grid-view.component';
import { ColmecEditContactModalComponent } from './components/colmec-edit-contact-modal/colmec-edit-contact-modal.component';
import { ColmecFilterListTopFilterComponent } from './components/colmec-filter-list-top-filter/colmec-filter-list-top-filter.component';
import { ColmecFilterListComponent } from './components/colmec-filter-list/colmec-filter-list.component';
import { ColmecHomeUserComponent } from './components/colmec-home-user/colmec-home-user.component';
import { ColmecHomeComponent } from './components/colmec-home/colmec-home.component';
import { ColmecInvoiceStatisticsChartCardComponent } from './components/colmec-invoice-statistics-chart-card/colmec-invoice-statistics-chart-card.component';
import { ColmecInvoiceStatisticsChartComponent } from './components/colmec-invoice-statistics-chart/colmec-invoice-statistics-chart.component';
import { ColmecLoginResetPasswordWrapperComponent } from './components/colmec-login-reset-password-wrapper/colmec-login-reset-password-wrapper.component';
import { ColmecLoginComponent } from './components/colmec-login/colmec-login.component';
import { ColmecNavbarCartComponent } from './components/colmec-navbar-cart/colmec-navbar-cart.component';
import { ColmecNavbarComponent } from './components/colmec-navbar/colmec-navbar.component';
import { ColmecOpenOrderTableComponent } from './components/colmec-open-order-table/colmec-open-order-table.component';
import { ColmecOrderDetailsComponent } from './components/colmec-order-details/colmec-order-details.component';
import { ColmecPartnerAgreementsListViewComponent } from './components/colmec-partner-agreements-list-view/colmec-partner-agreements-list-view.component';
import { ColmecPartnerAgreementsListComponent } from './components/colmec-partner-agreements-list/colmec-partner-agreements-list.component';
import { ColmecProductDetailsComponent } from './components/colmec-product-details/colmec-product-details.component';
import { ColmecSalespersonSelectComponent } from './components/colmec-salesperson-select/colmec-salesperson-select.component';
import { ColmecStartupCustomPageTemplateComponent } from './components/colmec-startup-custom-page-template/colmec-startup-custom-page-template.component';
import { ColmecTopProductGridViewComponent } from './components/colmec-top-product-grid-view/colmec-top-product-grid-view.component';
import { ColmecLastSevenDaysOrdersSummaryCardComponent } from './components/dashboard/colmec-last-seven-days-orders-summary-card/colmec-last-seven-days-orders-summary-card.component';
import { ColmecLastVsThisMonthSalesAmountSummaryCardComponent } from './components/dashboard/colmec-last-vs-this-month-sales-amount-summary-card/colmec-last-vs-this-month-sales-amount-summary-card.component';
import { ColmecLastVsThisWeekSalesAmountSummaryCardComponent } from './components/dashboard/colmec-last-vs-this-week-sales-amount-summary-card/colmec-last-vs-this-week-sales-amount-summary-card.component';
import { ColmecLastVsThisYearSalesAmountSummaryCardComponent } from './components/dashboard/colmec-last-vs-this-year-sales-amount-summary-card/colmec-last-vs-this-year-sales-amount-summary-card.component';
import { ColmecSalesSummaryCardComponent } from './components/dashboard/colmec-sales-summary-card/colmec-sales-summary-card.component';
import { ColmecJeevesProductCardComponent } from './components/product/colmec-jeeves-product-card/colmec-jeeves-product-card.component';
import { ColmecJeevesProductTableComponent } from './components/product/colmec-jeeves-product-table/colmec-jeeves-product-table.component';
import { ColmecProductListComponent } from './components/product/colmec-product-list/colmec-product-list.component';
import { ColmecProductSymbolsComponent } from './components/product/colmec-product-symbols/colmec-product-symbols.component';
import { ColmecWorkingOrderButtonsComponent } from './components/working-order/colmec-working-order-buttons/colmec-working-order-buttons.component';
import { ColmecWorkingOrderStepIndicatorComponent } from './components/working-order/colmec-working-order-step-indicator/colmec-working-order-step-indicator.component';
import { ColmecWorkingOrderWrapperComponent } from './components/working-order/colmec-working-order-wrapper/colmec-working-order-wrapper.component';
import { ColmecInitWorkingOrderObjectStepComponent } from './components/working-order/steps/colmec-init-working-order-object-step/colmec-init-working-order-object-step.component';
import { ColmecWorkingOrderBasicInfoStepComponent } from './components/working-order/steps/colmec-working-order-basic-info-step/colmec-working-order-basic-info-step.component';
import { ColmecWorkingOrderExtrasStepComponent } from './components/working-order/steps/colmec-working-order-extras-step/colmec-working-order-extras-step.component';
import { ColmecWorkingOrderServicesStepComponent } from './components/working-order/steps/colmec-working-order-services-step/colmec-working-order-services-step.component';
import { ColmecWorkingOrderStepComponent } from './components/working-order/steps/colmec-working-order-step/colmec-working-order-step.component';
import { ColmecWorkingOrderSummaryStepComponent } from './components/working-order/steps/colmec-working-order-summary-step/colmec-working-order-summary-step.component';
import { ColmecWorkingOrderTiresStepComponent } from './components/working-order/steps/colmec-working-order-tires-step/colmec-working-order-tires-step.component';
import { ColmecCartConfigService } from './services/cart/colmec-cart.config.service';
import { ColmecNavbarCartService } from './services/cart/colmec-navbar-cart.service';
import { ColmecSalesCartConfigService } from './services/cart/colmec-sales-cart-config.service';
import { ColmecCheckoutQuantityValidationService } from './services/checkout/colmec-checkout-quantity-validation.service';
import { ColmecActivityInternalListConfigService } from './services/colmec-activity-internal-list-config.service';
import { ColmecAvailabilityHelperService } from './services/colmec-availability-helper.service';
import { ColmecBackendInterceptorService } from './services/colmec-backend-interceptor.service';
import { ColmecCartService } from './services/colmec-cart.service';
import { ColmecCheckoutConfigService } from './services/colmec-checkout-config.service';
import { ColmecCustomPageConfigService } from './services/colmec-custom-page-config.service';
import { ColmecCustomPageResolverService } from './services/colmec-custom-page-resolver.service';
import { ColmecCustomerActionConfigService } from './services/colmec-customer-action-config.service';
import { ColmecCustomerContactListingConfigService } from './services/colmec-customer-contact-listing-config.service';
import { ColmecCustomerListConfigService } from './services/colmec-customer-list-config.service';
import { ColmecCustomerService } from './services/colmec-customer.service';
import { ColmecDashboardCardService } from './services/colmec-dashboard-card.service';
import { ColmecDashboardKpiService } from './services/colmec-dashboard-kpi.service';
import { ColmecDeliveryDatesService } from './services/colmec-delivery-dates.service';
import { ColmecDigitalAssetsListConfigService } from './services/colmec-digital-assets-list-config.service';
import { ColmecFilterListServiceService } from './services/colmec-filter-list-service.service';
import { ColmecJeevesModalService } from './services/colmec-jeeves-modal.service';
import { ColmecModalService } from './services/colmec-modal.service';
import { ColmecNavbarConfigService } from './services/colmec-navbar-config.service';
import { ColmecPriceConfigService } from './services/colmec-price-config.service';
import { ColmecPriceService } from './services/colmec-price.service';
import { ColmecProductListByIdsConfigService } from './services/colmec-product-list-by-ids-config.service';
import { ColmecProductListConfigService } from './services/colmec-product-list-config.service';
import { ColmecTranslationLocalService } from './services/colmec-translation-local.service';
import { ColmecUsersService } from './services/colmec-users.service';
import { ColmecJeevesOrderActionConfigService } from './services/order/colmec-jeeves-order-action-config.service';
import { ColmecOpenOrdersConfigService } from './services/order/colmec-open-orders-config.service';
import { ColmecDiscountsComponent } from './components/colmec-discounts/colmec-discounts.component';
import { ColmecDiscountListViewComponent } from './components/colmec-discounts/colmec-discount-list-view/colmec-discount-list-view.component';
import { ColmecDiscountImportModalComponent } from './components/colmec-discounts/colmec-discount-import-modal/colmec-discount-import-modal.component';
import { ColmecTirePolicyListComponent } from './components/tire-policy/colmec-tire-policy-list/colmec-tire-policy-list.component';
import { ColmecTirePolicyImportModalComponent } from './components/tire-policy/colmec-tire-policy-import-modal/colmec-tire-policy-import-modal.component';
import { ColmecTirePolicyTableViewComponent } from './components/tire-policy/colmec-tire-policy-table-view/colmec-tire-policy-table-view.component';
import { ColmecWorkingOrderListComponent } from './components/working-order/colmec-working-order-list/colmec-working-order-list.component';
import { ColmecWorkingOrderTableViewComponent } from './components/working-order/colmec-working-order-table-view/colmec-working-order-table-view.component';
import { ColmecWorkingOrderDetailsComponent } from './components/working-order/colmec-working-order-details/colmec-working-order-details.component';
import { ColmecPimProductComponent } from './components/colmec-pim-product/colmec-pim-product.component';
import { ColmecPimProductBasicInfoComponent } from './components/colmec-pim-product-basic-info/colmec-pim-product-basic-info.component';

@NgModule({ declarations: [
        ColmecAppComponent,
        ColmecProductDetailsComponent,
        ColmecCheckoutStepDubbingComponent,
        ColmecAppWrapperComponent,
        ColmecCheckoutStepOrderTermsComponent,
        ColmecJeevesProductTableComponent,
        ColmecSalesCartListComponent,
        ColmecSalesCartRowComponent,
        ColmecSummarizeOrderJeevesComponent,
        ColmecHomeComponent,
        ColmecProductSymbolsComponent,
        ColmecJeevesProductCardComponent,
        ColmecNavbarComponent,
        ColmecOrderConfirmationComponent,
        ColmecNavbarCartComponent,
        ColmecOrderDetailsComponent,
        ColmecCustomerDetailsComponent,
        ColmecCartTotalStepComponent,
        ColmecAdminCartRowComponent,
        ColmecCartSummaryComponent,
        ColmecCartItemComponent,
        ColmecDeliveryLocationsJeevesComponent,
        ColmecCheckoutStepOrderTermsUserComponent,
        ColmecBuyBtnComponent,
        ColmecAvailabilityWarningComponent,
        ColmecFilterListComponent,
        ColmecRimOptionsModalComponent,
        ColmecRimListByIdsComponent,
        ColmecRimCardComponent,
        ColmecProductListComponent,
        ColmecLoginComponent,
        ColmecLoginResetPasswordWrapperComponent,
        ColmecCartListLayoutComponent,
        ColmecAssignJeevesDefaultsComponent,
        ColmecHomeUserComponent,
        ColmecTopProductGridViewComponent,
        ColmecFilterListTopFilterComponent,
        ColmecCheckoutWrapperComponent,
        ColmecCartListButtonsComponent,
        ColmecButtonsComponent,
        ColmecStartupCustomPageTemplateComponent,
        ColmecLastVsThisYearSalesAmountSummaryCardComponent,
        ColmecLastVsThisMonthSalesAmountSummaryCardComponent,
        ColmecLastVsThisWeekSalesAmountSummaryCardComponent,
        ColmecLastSevenDaysOrdersSummaryCardComponent,
        ColmecSalesSummaryCardComponent,
        ColmecConceptDetailsComponent,
        ColmecConceptDetailsModalComponent,
        ColmecConceptProductsTableComponent,
        ColmecSalespersonSelectComponent,
        ColmecClaimListComponent,
        ColmecClaimTableViewComponent,
        ColmecClaimGridViewComponent,
        ColmecClaimCreateModalComponent,
        ColmecInvoiceStatisticsChartCardComponent,
        ColmecInvoiceStatisticsChartComponent,
        ColmecDigitalAssetsGridViewComponent,
        ColmecCustomerContactCardListComponent,
        ColmecEditContactModalComponent,
        ColmecAddCustomerModalComponent,
        ColmecActivityInternalCreateModalComponent,
        ColmecAddContactModalComponent,
        ColmecActivityInternalTableComponent,
        ColmecActivityInternalViewModalComponent,
        ColmecOpenOrderTableComponent,
        ColmecPartnerAgreementsListComponent,
        ColmecPartnerAgreementsListViewComponent,
        ColmecCreateEditPartnerAgreementModalComponent,
        ColmecWorkingOrderWrapperComponent,
        ColmecWorkingOrderStepComponent,
        ColmecWorkingOrderButtonsComponent,
        ColmecWorkingOrderStepIndicatorComponent,
        ColmecInitWorkingOrderObjectStepComponent,
        ColmecWorkingOrderBasicInfoStepComponent,
        ColmecWorkingOrderTiresStepComponent,
        ColmecWorkingOrderServicesStepComponent,
        ColmecWorkingOrderExtrasStepComponent,
        ColmecWorkingOrderSummaryStepComponent,
        ColmecDiscountsComponent,
        ColmecDiscountListViewComponent,
        ColmecDiscountImportModalComponent,
        ColmecTirePolicyListComponent,
        ColmecTirePolicyImportModalComponent,
        ColmecTirePolicyTableViewComponent,
        ColmecWorkingOrderListComponent,
        ColmecWorkingOrderTableViewComponent,
        ColmecWorkingOrderDetailsComponent,
        ColmecPimProductComponent,
        ColmecPimProductBasicInfoComponent
    ],
    bootstrap: [ColmecAppComponent], imports: [NgChartsModule,
        BrowserModule,
        BrowserAnimationsModule,
        GungStandardModule,
        GungStandardJeevesModule,
        GungCommonModule,
        GungListModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        GungDashboardModule,
        RouterModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLocalLoader,
                deps: [TranslationLocalService]
            }
        })], providers: [
        { provide: 'environment', useValue: environment },
        {
            provide: GOOGLE_ANALYTICS_ID,
            useValue: environment.analyticsId
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ColmecBackendInterceptorService,
            multi: true
        },
        {
            provide: NavbarCartService,
            useClass: ColmecNavbarCartService
        },
        {
            provide: BackendInterceptor,
            useClass: ColmecBackendInterceptorService
        },
        {
            provide: DeliveryDateService,
            useClass: ColmecDeliveryDatesService
        },
        {
            provide: TranslationLocalService,
            useClass: ColmecTranslationLocalService
        },
        {
            provide: AvailabilityHelperService,
            useClass: ColmecAvailabilityHelperService
        },
        {
            provide: CartService,
            useClass: ColmecCartService
        },
        {
            provide: ProductListConfigService,
            useClass: ColmecProductListConfigService
        },
        {
            provide: CheckoutConfigService,
            useClass: ColmecCheckoutConfigService
        },
        {
            provide: SalesCartConfigService,
            useClass: ColmecSalesCartConfigService
        },
        {
            provide: SalesCartConfigService,
            useClass: ColmecSalesCartConfigService
        },
        {
            provide: ProductListByIdsConfigService,
            useClass: ColmecProductListByIdsConfigService
        },
        {
            provide: JeevesOrderActionConfigService,
            useClass: ColmecJeevesOrderActionConfigService
        },
        {
            provide: CartConfigService,
            useClass: ColmecCartConfigService
        },
        {
            provide: CheckoutQuantityValidationService,
            useClass: ColmecCheckoutQuantityValidationService
        },
        {
            provide: OpenOrdersConfigService,
            useClass: ColmecOpenOrdersConfigService
        },
        {
            provide: PriceService,
            useClass: ColmecPriceService
        },
        {
            provide: CustomPageResolverService,
            useClass: ColmecCustomPageResolverService
        },
        {
            provide: CustomPageConfigService,
            useClass: ColmecCustomPageConfigService
        },
        {
            provide: UsersService,
            useClass: ColmecUsersService
        },
        {
            provide: NavbarConfigService,
            useClass: ColmecNavbarConfigService
        },
        {
            provide: DashboardCardService,
            useClass: ColmecDashboardCardService
        },
        {
            provide: DashboardKpiService,
            useClass: ColmecDashboardKpiService
        },
        {
            provide: PriceConfigService,
            useClass: ColmecPriceConfigService
        },
        {
            provide: FilterListService,
            useClass: ColmecFilterListServiceService
        },
        {
            provide: JeevesCustomerActionConfigService,
            useClass: ColmecCustomerActionConfigService
        },
        {
            provide: DigitalAssetsListConfigService,
            useClass: ColmecDigitalAssetsListConfigService
        },
        {
            provide: CustomerContactListConfigService,
            useClass: ColmecCustomerContactListingConfigService
        },
        {
            provide: JeevesModalService,
            useClass: ColmecJeevesModalService
        },
        {
            provide: CustomerService,
            useClass: ColmecCustomerService
        },
        {
            provide: GungModalService,
            useClass: ColmecModalService
        },
        {
            provide: ActivityInternalListConfigService,
            useClass: ColmecActivityInternalListConfigService
        },
        {
            provide: CustomerListConfigService,
            useClass: ColmecCustomerListConfigService
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class ColmecAppModule { }
